// extracted by mini-css-extract-plugin
export default {"tabContainer":"CourierList_tabContainer__dneSK","tabs":"CourierList_tabs__P79hl"};